module.exports = __webpack_public_path__ + "img/france.3c59a185.svg";